import { useMatches } from 'react-router-dom';

import type { TopBarHandle } from './types';

/**
 * 현재 매칭된 라우트 중 가장 안쪽(구체적인) `handle`을 읽는다.
 * `useMatches()`는 라우트 매칭과 같은 렌더 틱에 값이 확정되므로, mount 후 useEffect로 title을
 * set하는 방식과 달리 페이지 전환 중 깜빡임·추가 리렌더가 없다.
 *
 * AppTopBar(실제 title 행 렌더)와 MainLayout(그 행만큼 --nav-h를 늘릴지 계산) 양쪽이 이 훅을 같이 써서
 * "title 행이 있다/없다" 판단 기준을 한 곳에 두고 항상 동기화한다 — 한쪽만 바뀌면 title 행이 잘리거나
 * 빈 공간이 남는 문제(직전에 겪은 버그)가 재발한다.
 */
export function useTopBarHandle() {
  const matches = useMatches();
  const handle = matches.map((m) => m.handle as TopBarHandle | undefined).findLast(Boolean);

  return {
    title: handle?.title,
    showBack: handle?.showBack ?? false,
    /** title이나 뒤로가기 버튼 중 하나라도 있으면 title 행 자체를 보여준다 (Home처럼 둘 다 없으면 행을 아예 접는다) */
    hasRow: Boolean(handle?.title) || Boolean(handle?.showBack),
  };
}
